import React from 'react';

import ReactDOM from "react-dom";

import { withStyles, ThemeProvider, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Grid, IconButton, InputAdornment, TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import CardMedia from '@material-ui/core/CardMedia';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { AppState, Actions, store, PanelState, Values, IPageState } from '../../appredux';

import { connect, Provider } from 'react-redux';

import moment from "moment";

import { Trans } from 'react-i18next';

import { Formik, Form, FormikProps, FormikTouched, FormikErrors } from 'formik';

import { OrderAsort, bookService, vscPayment, payService, ReservationId, Nip, gusService, Info, WWWSprzedazInfo, UserData, ZamowService, telefonService, PrefiksPl, AsortGrupyWiersz } from '../../api';

import CONFIG from '../../cfg/config';

import DialogEnd from '../dialog/End';
import SmsCode from '../dialog/SmsCode';

import themeDialog from '../../themes-dialog';
import { outerTheme } from '../../themes';

import { normalizeText, zbudujLiczbeLosowa, wciecie, obetnijTekst, sendErrorLog, daysFromDate, phoneSplit } from '../common/helpers';

import { FieldTypes, FormFields, renderFields } from '../common/formFields/renderFields';
import { PoleDlugosciJednoWWierszu, InputTypes } from '../common/formFields/formularzStaleWspolne';


import { FormularzLabels, FormikFieldNames } from './formularzStale';
import { FormikTextFieldProps } from '../common/formFields/FormikTextField';
import DialogInfo from './DialogInfo';
import DialogMapaInpost from './DialogMapaInpost';
import DialogZamInfoError from '../dialog/ZamInfoOkError';

import {MenuItemProps, MuiSelectProps} from '../common/formFields/MuiSelect'
import DialpadIcon from '@mui/icons-material/Dialpad';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MapIcon from '@mui/icons-material/Map';
import Klawiatura from 'app/components/Klawiatura';
import MapDialog from 'app/components/MapDialog';
import ZamInfoOdlegloscError from 'app/dialog/ZamInfoOdlegloscError';

import { OpenStreetMapProvider } from 'leaflet-geosearch';
import { HaversineInM } from 'app/map_new/Distance';
import { MapData } from 'app/map_new/MapContainer';

import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaidIcon from '@mui/icons-material/Paid';

import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import PinIcon from '@mui/icons-material/Pin';
import InfoIcon from '@mui/icons-material/Info';

export type Content = {
  message: string,
  messageBoldPrimary?: string,
  icon?: any,
  color?: string,
}

//PM 2021-11-03
//wstrzykniecie tylko uzywanych pol z magazynu danych
type DialogOrderProps = {
  page: IPageState,
  basket: AsortGrupyWiersz[],
  contact: Info,
  info: WWWSprzedazInfo & {
    ip: string;
  },
  initialValues: Values,
  userData: UserData,
  close: () => void,
  open: boolean,
  message?: string,
  czarnaLista: any[],
  prefiksyPl: PrefiksPl[],
}

type DialogOrderState = {
  open: boolean,
  openStatus: boolean,
  openPaymentMethod: boolean,
  openNIP: boolean,
  openInfo: boolean,
  infoValues: Content[],
  NIP: Nip,
  paymentMethod: string,
  userInfo: Values,
  dataDostawy: string,

  openKlawiatura1: boolean,
  openKlawiatura2: boolean,
  openMapa: boolean,

  kurier: number,
  openMapaInpost: boolean,
  paczkomat: any
}

class DialogOrder extends React.Component<WithStyles<typeof styles> & DialogOrderProps, DialogOrderState> {

  private inputRefPhone: React.RefObject<HTMLInputElement>;
  private inputRefAdress: React.RefObject<HTMLInputElement>;
  private inputRefNip: React.RefObject<HTMLInputElement>;
  private inputRefEmail: React.RefObject<HTMLInputElement>;

  constructor(props: WithStyles<typeof styles> & DialogOrderProps) {
    super(props, {});

    this.inputRefPhone = React.createRef();
    this.inputRefAdress = React.createRef();
    this.inputRefNip = React.createRef();

    this.inputRefEmail = React.createRef();

    this.state = {
      open: true,
      openStatus: false,
      openPaymentMethod: false,
      openNIP: false,
      openInfo: false,
      infoValues: [],
      NIP: new Nip(),
      paymentMethod: "",
      userInfo: { phone: 0, address: '', NIP: '', Date: '', email: '' },
      dataDostawy: (this.getDateList().length > 0) ? this.getDateList()[0].value.toString() : '',

      openKlawiatura1: true,
      openKlawiatura2: false,
      openMapa: false,

      kurier: 0,
      openMapaInpost: false,
      paczkomat: {}

    };
  }

  logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/logo.png`;

  closeDialogInfo = () => {
    this.setState({ ...this.state, openInfo: false });
}

submitDialogInfo = async () => {

  let resdata: OrderAsort[] = [];

  let allItems: AsortGrupyWiersz[] = []; 
  allItems = [...this.props.basket, ...this.opakowania(), ...this.dowoz()]

    for (const basketItem of allItems)
      resdata.push({
        stawka_vat: basketItem.vat_stawka,
        mag_id: basketItem.mag_id.toString(),
        asort_id: basketItem.asort_id.toString(),
        asort_nazwa: basketItem.asort_nazwa,
        cena: basketItem.cena
});

      await store.dispatch(Actions.pageState.setPanelState(PanelState.psReservPending));
      await this.sendReservation(resdata, this.state.userInfo, this.state.paymentMethod);

}

  componentDidUpdate(prevProps: DialogOrderProps, prevState: DialogOrderState) {
      if(this.props.open !== prevProps.open && this.props.open)
        this.setState({
          openInfo: false,
          openKlawiatura1: true,
        });    
    };

    selectKurier = (k: number) => {
      let wybranyPaczkomat = this.state.paczkomat.address && this.state.paczkomat.location_description

      this.setState({kurier: k})
      if(k === 2 && !wybranyPaczkomat){
        this.setState({openMapaInpost: true})
      }
    }

    pointSelect = (point: any) => {
      console.log('Object of selected point: ', point);
      this.setState({paczkomat: point})
      this.setCloseMapaInpost()  
    }

    

    phoneCheck1 = async (phone: string) : Promise<string> => {
      const { classes } = this.props;
  
      if(phone.length < 9){
        return "Niepoprawny numer telefonu"
      }

      if(this.props.czarnaLista.find((x: {tel: string}) => phone.includes(x.tel))){
        //czarna lista
        return "Niepoprawny numer telefonu"
      }

      if(!this.poprawnyPolskiNumer(phone, 0, 2, this.props.prefiksyPl)){
        return "Niepoprawny numer telefonu"
      }
  
      try {
        let res = await telefonService.sprawdzNrTelefonu( {nrTelefonu: phone}, {} )
  
        if(Number(res.result) > 0){
          return ""
        }
        return "Niepoprawny numer telefonu"
  
      } catch (error) {
          sendErrorLog("0", "-1", 'vscSms/sms/sprawdzNrTelefonu')
          await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/sms/sprawdzNrTelefonu", 2))
          console.log(error);
      }
      return ""
    }

    poprawnyPolskiNumer = (phone: string, start: number, end: number, prefiksy: PrefiksPl[]): boolean => {
      let ret = false
      if(prefiksy.length === 0) return true
      prefiksy.forEach(x => {
        if(phone.substring(start, end) === x.prefiks) ret = true
      })
      return ret
    }

    setOpenKlawiatura1 = () => {
      this.setState({openKlawiatura1: true})
    }

    setCloselawiatura1 = (focusNext: boolean) => {
      this.setState({openKlawiatura1: false})

      setTimeout(() => {
        try {

          if(focusNext){
            if(CONFIG.inPost === "1" && this.inputRefEmail){
              // @ts-ignore
              this.inputRefEmail.current.focus();
              //this.setState({openMapa: true})
            }
            else if(this.inputRefAdress){
              // @ts-ignore
              //this.inputRefAdress.current.focus();
              this.setState({openMapa: true})
            }
          } else {
            if(this.inputRefPhone){
              // @ts-ignore
              this.inputRefPhone.current.focus();
            }
          }
          
        } catch (error) {} 
      }, 100);
     
    }

    setOpenKlawiatura2 = () => {
      this.setState({openKlawiatura2: true})
    }

    setCloselawiatura2 = (focusNext: boolean) => {
      this.setState({openKlawiatura2: false})

      setTimeout(() => {
        try {

          if(focusNext){
            //if(this.inputRefAdress){
            //  // @ts-ignore
            //  this.inputRefAdress.current.focus();
            //}
          } else {
            if(this.inputRefNip){
              // @ts-ignore
              this.inputRefNip.current.focus();
            }
          }
          
        } catch (error) {} 
      }, 100);

    }

    setOpenMapaInpost = () => {
      this.setState({openMapaInpost: true})
    }

    setCloseMapaInpost = () => {
      this.setState({openMapaInpost: false})
    }  

    setOpenMapa = () => {
      this.setState({openMapa: true})
    }

    setCloseMapa = (focusNext: boolean) => {
      this.setState({openMapa: false})

      setTimeout(() => {
        try {

          if(focusNext){
            if(this.inputRefNip){
              // @ts-ignore
              this.inputRefNip.current.focus();
              //this.setState({openKlawiatura2: true})
            }
          } else {
            if(this.inputRefAdress){
              // @ts-ignore
              this.inputRefAdress.current.focus();
             }
          }
          
        } catch (error) {} 
      }, 100);


    }

  //szuka danych po NIPie i otwierda dialog
  sprawdzNIP = async (NIPParam: string) => {
    try {
      let NIP: Nip = await gusService.dajDanePoNip({ nip: NIPParam })

      this.setState({ ...this.state, NIP: NIP, openNIP: true });
    }
    catch (error) {
      this.setState({ ...this.state, NIP: { ...new Nip(), nipOdpowiedz: NIPParam }, openNIP: true });
      await sendErrorLog( "0", "-1", '/vscSms/gus/dajDanePoNip/')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/vscSms/gus/dajDanePoNip/", 2))
      console.log(error)
    }
  };

  //szuka danych po NIPie i otwierda dialog
  sprawdzNIP2 = async (nip: string) => {
    nip = nip.split(" ").join("")
    if(!nip) return false
    if(nip.length < 9 || nip.length > 10) return true
    try {
      let NIP: Nip = await gusService.dajDanePoNip({ nip: nip })
      if (NIP.nazwa) return false
      else return true

    }
    catch (error) {
      await sendErrorLog("0", "-1", '/vscSms/gus/dajDanePoNip/')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/vscSms/gus/dajDanePoNip/", 2))
      console.log(error)
    }
    return true
  };

  opakowaniaOpis = (): string => {
    let ileOpakowan: number = 0;

    let opakowanie1 = this.props.page.asort.flat().find(x => x.tag_06 === "1")
    let opakowanie2 = this.props.page.asort.flat().find(x => x.tag_07 === "1")
    let opakowanie3 = this.props.page.asort.flat().find(x => x.tag_08 === "1")

    

    for (const itm of this.props.basket) {
      if(itm.tag_01 === "1" && opakowanie1){
        ileOpakowan++;
      }
      if(itm.tag_02 === "1" && opakowanie2){
        ileOpakowan++;
      }
      if(itm.tag_03 === "1" && opakowanie3){
        ileOpakowan++;
      }
    }


    let opakowaniaOpis = ""
    
    if(ileOpakowan === 1){
      opakowaniaOpis = `${ileOpakowan} sztuka`
    } else if(ileOpakowan === 2 || ileOpakowan === 3 || ileOpakowan === 4) {
      opakowaniaOpis = `${ileOpakowan} sztuki`
    } else if(ileOpakowan >= 5) {
      opakowaniaOpis = `${ileOpakowan} sztuk`
    } else {
      opakowaniaOpis = `0 sztuk`
    }
    
    return opakowaniaOpis
  }

  asortOpis = (): string => {
    let asortOpis = ""

    let ileItems: number = 0;
    
    for (const itm of this.props.basket) {
      ileItems++;
    }

    if(ileItems === 1){
      asortOpis = `${ileItems} pozycja`
    } else if(ileItems === 2 || ileItems === 3 || ileItems === 4) {
      asortOpis = `${ileItems} pozycje`
    } else if(ileItems >= 5) {
      asortOpis = `${ileItems} pozycji`
    } else {
      asortOpis = `0 pozycji`
    }
    
    return asortOpis;
  }

  opakowania = () : AsortGrupyWiersz[] => {
    let opakowania: AsortGrupyWiersz[] = [];
    
    let opakowanie1 = this.props.page.asort.flat().find(x => x.tag_06 === "1")
    let opakowanie2 = this.props.page.asort.flat().find(x => x.tag_07 === "1")
    let opakowanie3 = this.props.page.asort.flat().find(x => x.tag_08 === "1")


    for (const itm of this.props.basket) {
      if(itm.tag_01 === "1" && opakowanie1){
        opakowania.push(opakowanie1)
      }
      if(itm.tag_02 === "1" && opakowanie2){
        opakowania.push(opakowanie2)
      }
      if(itm.tag_03 === "1" && opakowanie3){
        opakowania.push(opakowanie3)
      } 
    }
    return opakowania
  }

  opakowaniaCena = () : number => {
    let sumOpakowania: number = 0;
    let items = this.opakowania()

    for (const itm of items) {
      sumOpakowania = sumOpakowania + parseFloat(itm.cena.replace(',', '.'));
    }

    return sumOpakowania;
  }


  dowoz = () : AsortGrupyWiersz[] => {
    let items: AsortGrupyWiersz[] = [];

    let distance = this.props.page.map.distance
    let dowoz1 = this.props.page.asort.flat().find(x => x.tag_11 === "1")
    let dowoz2 = this.props.page.asort.flat().find(x => x.tag_12 === "1")
    let dowoz3 = this.props.page.asort.flat().find(x => x.tag_13 === "1")

    if(distance > 0 && distance <= Number(CONFIG.dowozOkreg1) && dowoz1){
      items.push(dowoz1)
    } else if(distance > Number(CONFIG.dowozOkreg1) && distance <= Number(CONFIG.dowozOkreg2) && dowoz2){
      items.push(dowoz2)
    } else if(distance > Number(CONFIG.dowozOkreg2) && distance <= Number(CONFIG.dowozOkreg3) && dowoz3){
      items.push(dowoz3)
    } 

    return items;
  }

  dowozCena = () : number => {
    let sumDowoz: number = 0;
    let items = this.dowoz()

    for (const itm of items) {
      sumDowoz = sumDowoz + parseFloat(itm.cena.replace(',', '.'));
    }

    return sumDowoz;
  }

  koszykCena = () : number => {
    let sumItems: number = 0;

    for (const itm of this.props.basket) {
      sumItems = sumItems + parseFloat(itm.cena.replace(',', '.'));
    }
    return sumItems;
  }

  //PM 2021-11-03
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  handleSend = async (values: Values, paymentMethod: string) => {
    
    let zamOsobaInfoOK_showErrorDialog = false
    let zamOsobaInfoOK_message = ''

    if((this.props.userData.dostawaJakiDzien !== "")){
      let resZamOsobaInfoOK = await ZamowService.dajZamOsobaInfoOK({
        zamOsobaId: this.props.userData.zamOsobaId,
        zamFirmaId: this.props.userData.zamFirmaId,
        zamOddzialId: this.props.userData.zamOddzialId,
        telefon: String(values.phone), //this.props.userData.telefon,
        lokalPrzydzial: CONFIG.lokalPrzydzial,
        data: this.state.dataDostawy + ' 00:00:00'
      })

      if(resZamOsobaInfoOK.result && resZamOsobaInfoOK.result.length > 0){
        let result = resZamOsobaInfoOK.result[0]
        zamOsobaInfoOK_showErrorDialog = result.zamInfoOK === '0'
        
        if(zamOsobaInfoOK_showErrorDialog){
          if(result.zamOsobaIdOK === '0')
            zamOsobaInfoOK_message = 'Podane dane są niekompletne'
          else if(result.zamOsobaZaplatyOK === '0')
            zamOsobaInfoOK_message = 'Proszę uregulować zaległe płatności'
          else if(result.zamOsobaDostawyOK === '0')
            zamOsobaInfoOK_message = 'Masz już zamówienie na ten termin'
          else if(result.zamFirmaLokalOK === '0')
            zamOsobaInfoOK_message = 'Ten lokal nie przyjmuje twoich zamówień'
          else if(result.zamFirmaDostawaOK === '0')
            zamOsobaInfoOK_message = 'Zamówienia dla twojej firmy są już w drodze'
          else if(result.zamOddzialDostawaOK === '0')
            zamOsobaInfoOK_message = 'Zamówienia dla twojego oddziału są już w drodze'
        }
      }
    }

    if(zamOsobaInfoOK_showErrorDialog){
      let num : number = Math.random()

      ReactDOM.render(
        <Provider store={store}>
          <MuiThemeProvider theme={themeDialog}>
            <DialogZamInfoError randomNum={num} message={zamOsobaInfoOK_message} 
            data={{
              phone: String(values.phone),
              name: this.props.userData.nazwisko,
              date: this.state.dataDostawy + " " + this.getDayOfWeekFromStringDate(this.state.dataDostawy)
              }} />
          </MuiThemeProvider>
        </Provider>
        , document.getElementById("dialog"));
        
    }else{

      
    //////////////////////////////////////////////////////////////////////////
    let distance = this.props.page.map.distance

    let dowozError = false

    let czyAdres = values.address !== this.props.page.map.klientAdres

    if((distance === 0 || czyAdres) && CONFIG.inPost === "0"){

      try {
        const provider = new OpenStreetMapProvider();
        const results = await provider.search({ query: values.address });

        if(results && results[0]){
          let mapProp = this.props.page.map

          let dist = Math.round( HaversineInM(mapProp.obiektLat, mapProp.obiektLng, results[0].y, results[0].x))

          if(dist > Number(CONFIG.dowozOkreg3)){
            dowozError = true
          } else {

            let d = new MapData({
              klientAdres: values.address,//results[0].label,  
              klientLat: results[0].y, 
              klientLng: results[0].x,
              distance:  dist
            })
            await store.dispatch(Actions.pageState.setMap(d));
          }

          
          distance = dist
        }
        //console.log(results)


      } catch (error) {
          sendErrorLog("0", "-1", 'geolokalizacja leaflet-geosearch')
          await store.dispatch(Actions.pageState.addFcmLogMessage("geolokalizacja leaflet-geosearch", 2))
          console.log(error);
      }

    }

    ////////////////////////////////////////

      
    let num : number = Math.random()

    let sumItems: number = this.koszykCena();
    let sumOpakowania: number = this.opakowaniaCena();
    let sumDowoz: number = this.dowozCena()
    let sumWszystko: number = sumItems + sumOpakowania + sumDowoz;
    
    let opakowaniaOpis = this.opakowaniaOpis()
    let asortOpis = this.asortOpis()

    //let dowozError = false
    
    

    

    
    let distanceKM: string = "" 
    if(distance > 0){
      distanceKM = `${(distance / 1000).toFixed(1)}km`
    }

    if(distance > Number(CONFIG.dowozOkreg3)){
      dowozError = true
    }

    let cDataDostawy : Content = {
      message: wciecie + "data" + ': ',
      messageBoldPrimary: this.state.dataDostawy + ' ' + this.getDayOfWeekFromStringDate(this.state.dataDostawy)
    }

    const dialogContent: Content[] = [
        {
            //message: t('Added reservation') 
            message: "Czy na pewno zrobić zamówienie"
        },

        // {
        //     message: wciecie + t("Booking") + ': ',
        //     messageBoldPrimary: reservation.data_od + " / " + reservation.data_do,
        // },

        // {
        //     message: wciecie + t("ilość dni") + ': ',
        //     messageBoldPrimary: days(new Date(reservation.data_od), new Date(reservation.data_do)).toString()
        // },

       

        // {
        //     message: wciecie +  'zamówienie: ',
        //     messageBoldPrimary: sumItems.toFixed(2) + " zł" + asortOpis,
        // },
        // {
        //     message: wciecie +  'opakowania: ',
        //     messageBoldPrimary: sumOpakowania.toFixed(2) + " zł" + opakowaniaOpis,
        // },
        // {
        //     message: wciecie +  'dowóz: ',
        //     messageBoldPrimary: sumDowoz.toFixed(2) + " zł" + distanceKM,
        // },
        
        // {
        //     message: wciecie + ((this.props.userData.dostawaJakiDzien === "") ? 'do zapłaty' : 'kwota') + ': ',
        //     messageBoldPrimary: sumWszystko.toFixed(2) + " zł",
        // },
        {
            icon: ShoppingCartIcon,
            message: asortOpis,
            messageBoldPrimary: sumItems.toFixed(2) + " zł",
        },
        {
            icon: ShoppingBasketIcon,
            message: opakowaniaOpis,
            messageBoldPrimary: sumOpakowania.toFixed(2) + " zł" ,
        },
        {
            icon: DeliveryDiningIcon,
            message:  distanceKM,
            messageBoldPrimary: sumDowoz.toFixed(2) + " zł",
        },
        
        {
            icon: PaidIcon ,
            message: 'razem ',
            messageBoldPrimary: sumWszystko.toFixed(2) + " zł",
        },

        {
            message: " ",
            messageBoldPrimary: " ",
        },

        {
            icon: PhoneIcon,
            message: 'twój telefon',
            messageBoldPrimary: phoneSplit(values.phone.toString()),
        },

        {
            icon: LocationOnIcon,
            message: 'twój adres',
            messageBoldPrimary: values.address,
        },
        cDataDostawy,

        {
            icon: AccessTimeFilledIcon,
            message: ((this.props.userData.dostawaJakiDzien === "") ? "czas" : "godz"),
            messageBoldPrimary: ((this.props.userData.dostawaJakiDzien === "") ? this.props.info.www_sprzedaz_czas_oczekiwania_info : this.props.userData.dostawaGodzMinuta.split(' ')[1].replace(':00:00', ':00').replace(':30:00', ':30').replace(':15:00', ':15').replace(':45:00', ':45'))
        },
    ];

    if(czyAdres && CONFIG.inPost === "0"){
      dialogContent.push(
        {
          icon: InfoIcon,
          message: "uwaga",
          messageBoldPrimary: "adres został zmieniony",
          color: "rgb(255, 165, 0)"
      },
      )
    }

    if(values.NIP !== ""){
      dialogContent.push( {
        icon: PinIcon,
        message: 'twój NIP',
        messageBoldPrimary: values.NIP,
      },)
    }

    if(this.props.userData.dostawaJakiDzien === ""){
      this.removeItem(dialogContent, cDataDostawy)
    }else{
      dialogContent.push({
        message: wciecie + 'twoje logo' + ': ',
            messageBoldPrimary: this.props.userData.logo,
      })
    }

    if(dowozError){

      ReactDOM.render(
        <Provider store={store}>
          <MuiThemeProvider theme={themeDialog}>
            <ZamInfoOdlegloscError randomNum={num} 
            data={{
              distance: `${(Number(CONFIG.dowozOkreg3) / 1000).toFixed(1)}km`,
              distanceClient: `${(Number(distance) / 1000).toFixed(1)}km`,
              
              }} />
          </MuiThemeProvider>
        </Provider>
        , document.getElementById("dialog"));

    } else {
      this.setState({ ...this.state, openNIP: false, openInfo: true, userInfo: values, paymentMethod: paymentMethod , infoValues: dialogContent, });
    }

    


    }
    
  };

  removeItem<T>(arr: Array<T>, value: T): Array<T> { 
    const index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  //PM 2021-11-03
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async redirectToPayment(dokNr: number, kwota: string) {
    console.log("redirectToPayment")
    //http://test.vsc24.eu:8080/vscKelnerBookFoto/hotel/?hotelId=komora-TEST
    //http://test.vsc24.eu:8080/vscKelnerBookOK/hotel/?hotelId=komora-TEST
    //http://test.vsc24.eu:8080/vscKelnerBookNotOK/hotel/?hotelId=komora-TEST
    let href = window.location.href
    let positiveLink = href.replace("Foto/", "OK/");
    let negativeLink = href.replace("Foto/", "NotOK/");



    let id = ""
    if (this.props.contact.payWeb === '2')
      try {
        const res: vscPayment = await payService.getPaymentUrl1({
          hotelId: CONFIG.hotelID,
          dokNr: dokNr.toString(),
          kwota: kwota,
          opis: "Platnosc za zamowienie: " + String(dokNr),
          returnUrl: positiveLink,
          negativeReturnUrl: negativeLink
        })
        //console.log(res)
        id = res.id

        if (id)
          window.open(res.redirectUrl, '_blank');
        //window.open(window.location.href + 'testPlatnosci', '_blank');
      } catch (error) {
        console.log(error)
        await sendErrorLog( "0", "-1", '/vscSms/pay/payCashBillZaplac1')
        await store.dispatch(Actions.pageState.addFcmLogMessage("/vscSms/pay/payCashBillZaplac1", 2))
        this.props.close()
      }

    return id
  }

  //PM 2021-11-25
  //poprawka typow
  async sendReservation(order: OrderAsort[], values: Values, paymentMethod: string) {
    const nazwa = `${values.phone} ** ${normalizeText(values.address, "-", false)}`;

    let cookies = localStorage.getItem('cookies_zaakceptowane')
    if(cookies === "true"){
      if(values.phone ) localStorage.setItem('numer_telefonu', values.phone.toString());
      if(values.email ) localStorage.setItem('email', values.email.toString());
      if(values.address ) localStorage.setItem('adres', values.address);
      if(values.NIP ) localStorage.setItem('nip', values.NIP);
    }
    await store.dispatch(Actions.pageState.setInitialValues({ address: values.address, phone: values.phone, NIP: values.NIP, Date: '', email: values.email}));

    //aJsonDostawa
    let aJsonDostawa = {
      dostawa: "T",
      dostawa_data: this.state.dataDostawy, //daysFromDate(new Date(), 0),
      zam_firma: "T",
      zam_lokal: CONFIG.lokalPrzydzial,
      zam_firma_id: this.props.userData.zamFirmaId,
      zam_osoba_id: this.props.userData.zamOsobaId,
      zam_data: this.state.dataDostawy, //daysFromDate(new Date(), 0),
      zam_prywatne:"N" 
    }

    store.dispatch(Actions.pageState.setDostawaDataDzien(this.state.dataDostawy + ' ' + this.getDayOfWeekFromStringDate(this.state.dataDostawy)))

    try {
      const res: ReservationId = await bookService.orderNewPayment3({   //2
        hotelId: CONFIG.hotelID,
        aOperatorId: 1,
        aKontrId: 1,
        aKontrNazwa: nazwa,
        aSpZaplaty: 'GW',
        aInternetInfo: this.props.info.ip + ' - brak',
        aLiczbaLosowa: zbudujLiczbeLosowa(this.props.info.ip),
        aPayWeb: Number(paymentMethod),
        aZrodloWeb: 0,
        aNIP: values.NIP ? values.NIP.replace(/\D/g, '') : "",
        //aJSON: order,
        aJsonKoszyk: order,
        aJsonDostawa: aJsonDostawa
      })

      //////////////////////
      let sumItems: number = this.koszykCena();
      let sumOpakowania: number = this.opakowaniaCena();
      let sumDowoz: number = this.dowozCena()
      let sum: number = sumItems + sumOpakowania + sumDowoz;

      //let sum: number = 0;
      //for (const itm of order) {
      //  sum = sum + parseFloat(itm.cena.replace(',', '.'));
      //}

      /////////////////////////
      
      
      if(res.result[0] > 0 && this.props.userData.zamFirmaId !== "" && this.props.userData.zamOsobaId !== ""){
        let dataAndtime = {...this.props.userData, timestamp: new Date().getTime()}
        window.localStorage.setItem("userData", JSON.stringify(dataAndtime) )
      }

      if (paymentMethod === "3") {
        const data = { phone: values.phone.toString(), address: values.address, order: res.result[0], sum: sum, id: res.result[0] }
        await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
        this.props.close()
        ReactDOM.render(
          <Provider store={store}>
            <MuiThemeProvider theme={themeDialog}>
              <SmsCode data={data} content={this.state.infoValues}/>
            </MuiThemeProvider>
          </Provider>
          , document.getElementById("dialog_sms"));
        await store.dispatch(Actions.pageState.openDialogSms());

        return;
      }

      let id = ""
      if (paymentMethod === "2" || paymentMethod === "1") {
        id = await this.redirectToPayment(res.result[0], sum.toString());
      }

      if (res.result[0] <= 0) {
        const data = { phone: values.phone.toString(), address: values.address, order: res.result[0], sum: sum, id: res.result[0] }
        await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
        this.props.close()
        this.setState({openInfo: false})
        //store.dispatch(Actions.pageState.openDialogEnd());
        ReactDOM.render(
          <Provider store={store}>
            <MuiThemeProvider theme={themeDialog}>
              <DialogEnd success={false} data={data} paymentId={""} pay_web={paymentMethod} content={this.state.infoValues}/>
            </MuiThemeProvider>
          </Provider>
          , document.getElementById("dialog"));
        await store.dispatch(Actions.pageState.openDialogEnd());
      } else if (res.result[0] > 0) {
        const data = { phone: values.phone.toString(), address: values.address, order: res.result[0], sum: sum, id: res.result[0] }
        await store.dispatch(Actions.pageState.setPanelStateAndResetBasket(PanelState.psBrowse));
        this.props.close()
        this.setState({openInfo: false})
        //store.dispatch(Actions.pageState.openDialogEnd());
        ReactDOM.render(
          <Provider store={store}>
            <MuiThemeProvider theme={themeDialog}>
              <DialogEnd success={true} data={data} paymentId={id} pay_web={paymentMethod} content={this.state.infoValues}/>
            </MuiThemeProvider>
          </Provider>
          , document.getElementById("dialog"));
        await store.dispatch(Actions.pageState.openDialogEnd());
      }
    } catch (error) {
      alert('NIEPOWODZENIE!' + error);
      console.log(error)
      await sendErrorLog( "0", "-1", '/manager/fakturaKoszykDodaj2')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/fakturaKoszykDodaj2", 2))
      await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
      this.props.close()
      this.setState({openInfo: false})
    }
  }

  // closeDialogInfo = () => {
  //   this.setState({ open: false })
  // };
  

  closeDialogStatus = () => {
    this.setState({ openStatus: false })
  };

  closeDialogPaymentMethod = () => {
    this.setState({ openPaymentMethod: false })
    //this.setState({openPaymentMethod: false, paymentMethod: -1})
  };

  //selectPaymentMethod = (method: number) => {
  //  this.setState({paymentMethod: method})
  //}

  confirmPaymentMethod = (n: number) => {
    this.setState({ openPaymentMethod: false })
    this.handleSend(this.state.userInfo, n.toString())
    store.dispatch(Actions.pageState.setPaymentMethod(n));
  }

  // openDialogInfo = () => {
  //     this.setState({open: false})
  //     store.dispatch(Actions.pageState.openDialogOrder());
  // };

  zmienDataDostawy = (event: React.ChangeEvent<{ name?: string; value: unknown; }>, child: React.ReactNode) => {
    this.setState({ dataDostawy: String(event.target.value), });
  }

  //PM 2021-11-03
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  // fields = (): FormFields[] => {
  //   const { classes } = this.props;
  //   let sum: number = 0;
  //   for (const itm of this.props.basket) {
  //     sum = sum + parseFloat(itm.cena.replace(',', '.'));
  //   }
  //   const date = moment().format("HH:mm");

  //   return [
  //     {
  //       block: {
  //         type: FieldTypes.text,
  //         props: {
  //           key: FormularzLabels.DoZaplaty,
  //           formControlStyle: { marginBottom: 0, paddingBottom: '26px' },
  //           label: FormularzLabels.DoZaplaty,
  //           labelClasses: classes.blue,
  //           style: { width: PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
  //           inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightBold} ${classes.textField}`,
  //           value: sum.toFixed(2) + " zł",
  //           disabled: true,
  //         },
  //       },
  //     },
  //     {
  //       block: {
  //         type: FieldTypes.text,
  //         props: {
  //           key: FormularzLabels.CzasTeraz,
  //           formControlStyle: { marginBottom: 0, paddingBottom: '26px' },
  //           label: FormularzLabels.CzasTeraz,
  //           labelClasses: classes.blue,
  //           style: { width: PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
  //           inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightBold} ${classes.textField}`,
  //           value: date,
  //           disabled: true,
  //         },
  //       },
  //     },
  //     {
  //       block: {
  //         type: FieldTypes.text,
  //         props: {
  //           key: FormularzLabels.CzasDostawy,
  //           formControlStyle: { marginBottom: 0, paddingBottom: '26px' },
  //           label: FormularzLabels.CzasDostawy,
  //           labelClasses: classes.blue,
  //           style: { width: PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
  //           inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightBold} ${classes.textField}`,
  //           value: this.props.info.www_sprzedaz_czas_oczekiwania_info,
  //           disabled: true,
  //         },
  //       },
  //     },
  //     {
  //       block: {
  //         type: FieldTypes.text,
  //         props: {
  //           key: FormularzLabels.TerenDostawy,
  //           formControlStyle: { marginBottom: 0, paddingBottom: '26px' },
  //           label: FormularzLabels.TerenDostawy,
  //           labelClasses: classes.blue,
  //           style: { width: PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
  //           inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightBold} ${classes.textField}`,
  //           value: this.props.info.www_sprzedaz_dostawa_teren_opis,
  //           disabled: true,
  //         },
  //       },
  //     },
  //   ];
  // }

  day = (days: number, startDate: Date = new Date()) => {
    let nextDate = new Date( startDate ); //this.props.page.dateFrom
    nextDate.setDate(nextDate.getDate() + days);
    let mm = nextDate.getMonth() + 1;
    let dd = nextDate.getDate();
    let a = [nextDate.getFullYear(), "-",
    (mm > 9 ? '' : '0') + mm, "-",
    (dd > 9 ? '' : '0') + dd
    ].join('');
    return a;
  };

  getDayOfWeek = (param: number) => {
    return moment(this.day(param - 1).split(' ')[0]).locale("pl").format('YYYY-MM-DD dddd').split(' ')[1];
  }

  getDayOfWeekFromStringDate = (param: string) => {
    return moment(param.split(' ')[0]).locale("pl").format('YYYY-MM-DD dddd').split(' ')[1];
  }

  getDateItem = (param: number, list: MenuItemProps[]) => {
    let date = this.getDateFromWs(String(param))
    if(date != null)
      list.push( {value: date, text: date + ' ' + this.getDayOfWeek(param)} ) 
  }

  getDateItemOld = (param: number, startDate: Date = new Date()) => {
    return {value: daysFromDate(new Date(), param), text: daysFromDate(new Date(), param) + ' ' + this.getDayOfWeek(param)}
  }

  getDateFromWs = (param: string) => {
    switch(param){
      case "1":
        if(this.props.info.www_zam_dzien1OK === '1')
          return this.props.info.www_zam_dzien1
        else
          return null
      case "2":
        if(this.props.info.www_zam_dzien2OK === '1')
          return this.props.info.www_zam_dzien2
        else
          return null
      case "3":
        if(this.props.info.www_zam_dzien3OK === '1')
          return this.props.info.www_zam_dzien3
        else
          return null
      case "4":
        if(this.props.info.www_zam_dzien4OK === '1')
          return this.props.info.www_zam_dzien4
        else
          return null
      case "5":
        if(this.props.info.www_zam_dzien5OK === '1')
          return this.props.info.www_zam_dzien5
        else
          return null
      case "6":
        if(this.props.info.www_zam_dzien6OK === '1')
          return this.props.info.www_zam_dzien6
        else
          return null
      case "7":
        if(this.props.info.www_zam_dzien7OK === '1')
          return this.props.info.www_zam_dzien7
        else
          return null
      default:
        if(this.props.info.www_zam_dzien1OK === '1')
          return this.props.info.www_zam_dzien1
        else
          return null
    }
  }

  getDateList = () => {
    let daty : MenuItemProps[] = []
    switch (this.props.userData.dostawaJakiDzien) {
      case "0":
        this.getDateItem(1, daty)
        break;
      case "1":
        this.getDateItem(2, daty)
        break;
      case "2":
        this.getDateItem(1, daty)
        this.getDateItem(2, daty)
        this.getDateItem(3, daty)
        this.getDateItem(4, daty)
        this.getDateItem(5, daty)
        this.getDateItem(6, daty)
        this.getDateItem(7, daty)
        break;
      case "3":
        this.getDateItem(2, daty)
        this.getDateItem(3, daty)
        this.getDateItem(4, daty)
        this.getDateItem(5, daty)
        this.getDateItem(6, daty)
        this.getDateItem(7, daty)
        break;
    
      default:
        this.getDateItem(1, daty)
        break;
    }
    return daty;
  }

  //PM 2021-11-03
  //zrezygnowanie z formik-material-ui
  formikFields = (
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean
    ) => void,
    values: Values,
    handleChange: (e: React.ChangeEvent<any>) => void,
    touched: FormikTouched<Values>,
    errors: FormikErrors<Values>, 
    handleBlur: (e: React.FocusEvent<any, Element>) => void
  ): FormFields[] => {
    const { classes } = this.props;

    //let odd = this.props.page.firmaOddzialy.filter(x => x.doLikw === "N" )
    //let daty = odd.map(x =>  {return {value: x.zamOddzialId, text: x.opis}})
    let daty : MenuItemProps[] 
    daty = this.getDateList();

    let ret: any =  [
      {
        block: {
          type: FieldTypes.formikText,
          props: {
            autoComplete: "on",
            key: FormikFieldNames.Telefon,
            id: FormikFieldNames.Telefon + "Field",
            type: InputTypes.Number,
            formControlStyle: { marginTop: " 20px", },
            name: FormikFieldNames.Telefon,
            autoFocus: true,
            label: FormularzLabels.Telefon,
            labelClasses: classes.green,
            required: true,
            style: { width: PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
            inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightBold} ${classes.textField}`,
            value: values.phone === 0 ? "" : values.phone,
            onChange: handleChange,
            onBlur: handleBlur,
            //onClick: this.state.openKlawiatura1 ? () =>{} : () => this.setOpenKlawiatura1(),
            //onFocus: this.state.openKlawiatura1 ? () =>{} : () => this.setOpenKlawiatura1(),
            endAdornment:(
              <InputAdornment position="start" style={{ padding: "0" }} >

                <IconButton id="klawiaturaIcon1"
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={this.setOpenKlawiatura1}
                  style={{ padding: "8px", marginRight: "-18px" }}
                >
                    <DialpadIcon style={{ fontSize: "1rem" }} />
                </IconButton>
                <Klawiatura open={this.state.openKlawiatura1} number={values.phone} setNumber={setFieldValue} fieldName={FormikFieldNames.Telefon} close={this.setCloselawiatura1} title={"wpisz telefon"} placeholder="888 000 888" phoneMode max={9} error={errors.phone}/>
              </InputAdornment>
            ),
            touched: touched.phone,
            error: errors.phone,
            inputRef: this.inputRefPhone,
            labelIcon: PhoneIcon
          } as FormikTextFieldProps,
        },
      },
    ]

    if(CONFIG.inPost === "1"){
      ret.push(
        {
          block: {
            type: FieldTypes.formikText,
            props: {
              autoComplete: "on",
              key: FormikFieldNames.Email,
              id: FormikFieldNames.Email + "Field",
              //type: InputTypes.Text,
              formControlStyle: { marginTop: " 24px", },
              name: FormikFieldNames.Email,
              label: FormularzLabels.Email,
              labelClasses: classes.green,
              required: true,
              style: { width: PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
              inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightBold} ${classes.textField}`,
              value: values.email,
              onChange: handleChange,
              onBlur: handleBlur,
              touched: touched.email,
              error: errors.email,
              inputRef: this.inputRefEmail,
              labelIcon: EmailIcon
            } as FormikTextFieldProps,
          },
        },
      )
    }

     
    ret.push(
      
      {
        block: {
          type: FieldTypes.formikText,
          props: {
            //disabled: true,
            autoComplete: "on",
            key: FormularzLabels.Adres,
            id: FormularzLabels.Adres + "Field",
            formControlStyle: {  },
            name: FormikFieldNames.Adres,
            label: FormularzLabels.Adres,
            labelClasses: classes.green,
            required: true,
            style: { width: PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
            inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightBold} ${classes.textField}`,
            value: values.address,
            onChange: handleChange,
            onBlur: handleBlur,
            //onClick: this.setOpenMapa,
            endAdornment:(
              <InputAdornment position="start" style={{ padding: "0" }}  >
  
                <IconButton
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={this.setOpenMapa}
                  style={{ padding: "8px", marginRight: "-18px" }}
                >
                    <LocationOnOutlinedIcon style={{ fontSize: "1.2rem" }} />
                </IconButton>
                
              </InputAdornment>
            ),
            touched: touched.address,
            error: errors.address,
            inputRef: this.inputRefAdress,
            mapComponent: (<MapDialog open={this.state.openMapa} close={this.setCloseMapa} title={"wybierz lokalizację"} setAdress={setFieldValue}/>),
            labelIcon: LocationOnIcon,
          } as FormikTextFieldProps,
        },
      },
      {
        block: {
          type: FieldTypes.select,
          props: {
            key: FormularzLabels.Date,
            formControlStyle: {  },
            name: FormikFieldNames.Date,
            label: FormularzLabels.Date,
            labelClasses: classes.green,
            required: true,
            style: { width: PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC, color: 'seagreen', fontSize: '16px'},
            inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightBold} ${classes.textField}`,
            value: this.state.dataDostawy,
            data: daty,
            onChange: this.zmienDataDostawy,
            touched: touched.Date,
            error: errors.Date,
          } as MuiSelectProps,
        },
      }
    
    )

if(this.props.userData.dostawaJakiDzien === ""){
    ret.pop()
}

if(this.props.userData.zamOsobaId === "" && this.props.userData.zamFirmaId === "" ){
  ret.push(
    {
      block: {
        type: FieldTypes.formikText,
        
        props: {
          id: FormularzLabels.NIP + "Field",
          key: FormularzLabels.NIP,
          formControlStyle: { },
          name: FormikFieldNames.NIP,
          label: FormularzLabels.NIP,
          //type: InputTypes.Number,
          labelClasses: classes.green,
          style: { width: PoleDlugosciJednoWWierszu.CALA_DLUGOSC.value.PC },
          inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightBold} ${classes.textField}`,
          value: values.NIP,
          onChange: handleChange,
          //onBlur: () => this.sprawdzNIP2(errors),
          onBlur: handleBlur,
          //onClick: this.state.openKlawiatura2 ? () =>{} : () => this.setOpenKlawiatura2(),
          endAdornment:(
            <InputAdornment position="start" style={{ padding: "0" }}  >

              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={this.setOpenKlawiatura2}
                style={{ padding: "8px", marginRight: "-18px" }}
              >
                  <DialpadIcon style={{ fontSize: "1rem" }} />
              </IconButton>
              <Klawiatura open={this.state.openKlawiatura2} number={values.NIP} setNumber={setFieldValue} fieldName={FormikFieldNames.NIP} close={this.setCloselawiatura2} title={"wpisz NIP"} placeholder="813 00 00 813" max={10} error={errors.NIP} nipMode/>
            </InputAdornment>
          ),
          touched: touched.NIP,
          error: errors.NIP,
          inputRef: this.inputRefNip,
          labelIcon: PinIcon,
        } as FormikTextFieldProps,
      },
    }
    )
}

    return ret
    
  }

  setForm = (values: Values) => {
    store.dispatch(Actions.pageState.setInitialValues({ 
      address: values.address, 
      phone: Number(values.phone), 
      NIP: values.NIP, 
      Date: values.Date,
      email: values.email,

    }));
  }

  //dostawaJakiDzien

  //PM 2021-11-03
  //zrezygnowanie z formik-material-ui
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  render() {
    const classes = this.props.classes;

    let wybranyPaczkomat = this.state.paczkomat.address && this.state.paczkomat.location_description

   

    return (
      <>
        {this.state.openStatus ?
          <Dialog
            disableEscapeKeyDown
            maxWidth="xs"
            open={this.state.openStatus}
            fullWidth
          >
            <DialogTitle disableTypography >
              {/* <Typography variant="h5" component="h2" color="primary" style={{paddingBottom: "10px"}}>
                 <b>{"Szanowny Kliencie"}</b>   
              </Typography>  */}
              <Typography variant="h5" component="h2" color="primary">
                <b>{this.props.info.www_sprzedaz_error_info}</b>
              </Typography>
            </DialogTitle>
            <DialogContent >
              {/* <div style={{margin: "1em auto auto", display: "flex"}}>
            <ResponsiveImgMaterialUi style={{height: "70%", width: "70%", margin: "auto"}} 
              xs={logoUrl}
              md={logoUrl}
              lg={logoUrl}
            /> 
            </div> */}
              <CardMedia
                //tclassName={classes.media}
                style={{ height: "300px", width: "300px", margin: "auto" }}
                image={this.logoUrl}
              //title="logo"
              />
            </DialogContent>
            <DialogActions >
              <Button onClick={() => this.closeDialogStatus()} variant="outlined" size="small" color="primary"
                style={{ fontSize: "0.8rem" }}
              >
                <b><Trans>OK</Trans></b>
              </Button>
            </DialogActions>
          </Dialog> : null}
        {this.state.openPaymentMethod ?
          <Dialog
            disableEscapeKeyDown
            maxWidth="xs"
            open={this.state.openPaymentMethod}
            fullWidth
          >
            <DialogTitle disableTypography >
              <Typography variant="h5" component="h2" color="primary" style={{ textAlign: "center" }} >
                <b>{"wybierz jak płacisz"}</b>
                {/* <b>{"wybierz metodę płatności"}</b>    */}
              </Typography>
            </DialogTitle>
            <DialogContent >
              <Button onClick={() => this.confirmPaymentMethod(2)} variant="contained" size="small" color="primary"
                className={classes.button}
              >
                płatność w internecie
              </Button>
              <Button onClick={() => this.confirmPaymentMethod(3)} variant="contained" size="small" color="primary"
                className={classes.button}
              >
                płatność przy odbiorze
              </Button>

              <Button onClick={() => this.closeDialogPaymentMethod()} variant="outlined" size="small" color="primary"
                className={classes.button}
              >
                anuluj
              </Button>

              {/* <DialogContentText>
                <List component="nav">
                    <ListItem
                      button style={{ paddingRight: "30px", paddingLeft: "30px" }}
                      key="1"
                      selected={this.state.paymentMethod === 1}
                      onClick={() => this.selectPaymentMethod(1)}>
                      <ListItemText 
                      primary={<Typography className={classes.listText}  color="primary"><b>{"płatność w internecie"}</b></Typography>} 
                      secondary={""} />
                    </ListItem>
                    <ListItem
                      button style={{ paddingRight: "30px", paddingLeft: "30px" }}
                      key="2"
                      selected={this.state.paymentMethod === 2}
                      onClick={() => this.selectPaymentMethod(2)}>
                      <ListItemText  
                      primary={<Typography className={classes.listText} color="primary"><b>{"płatność przy odbiorze"}</b></Typography>} 
                      secondary={""} />
                    </ListItem>
                </List>
              </DialogContentText> */}
            </DialogContent>
            {/* <DialogActions >  
            <Button onClick={() => this.closeDialogPaymentMethod() }  variant="outlined" size="small" color="primary"
                    style={{ fontSize: "0.8rem", textTransform: "none" }}
            >
            <b>{"anuluj"}</b>
            </Button>  
            <Button onClick={() => this.confirmPaymentMethod() }  variant="contained" size="small" color="primary"
                    disabled={this.state.paymentMethod != 1 && this.state.paymentMethod != 2}
                    style={{ fontSize: "0.8rem" }}
            >
              <b><Trans>OK</Trans></b>
            </Button>
          </DialogActions>  */}
          </Dialog> : null}
        <Dialog
          disableEscapeKeyDown
          //maxWidth="lg"
          maxWidth="sm"
          open={this.props.open}
          classes={{paper: classes.papper}}
          fullWidth
        >
          <DialogContent style={{ padding: "16px 24px 8px 12px" }}>
            <Grid container spacing={0}>

              {/* /////////////////////////
              lewy panel
              /////////////////////////
              <Grid item xs={12} md={6} style={{ paddingLeft: "12px" }} > */}

              <Grid item xs={12} md={12} style={{ paddingLeft: "12px" }} >
                <DialogTitle disableTypography className={classes.dialogTitle}>
                  <Typography
                    gutterBottom variant="h5" component="h2" color="primary"
                    className={classes.dialogTitleTypography}>
                    <b>twoja dostawa</b>
                  </Typography>
                  <hr className={classes.hr} />
                </DialogTitle>
                {/* {renderFields(this.fields())} */}
                <Formik
                  //validateOnBlur
                  //validateOnChange={false}
                  initialValues={this.props.initialValues}
                  validate={async values => {
                    let errors = {}

                    //if (!values.phone.toString().replace(/\s/g, "").match(/(^\+\d{11,12}$)|(^\d{9,9}$)/)) {
                    ///////  
                    // if (!values.phone.toString().replace(/\s/g, "").match(/(^\d{11,12}$)|(^\d{9,9}$)/)) {
                    //   errors = { ...errors, phone: "Niepoprawny numer telefonu" };
                    // }
                    ///////////////
                    let phoneError = await this.phoneCheck1(values.phone.toString())
                    if(phoneError) {
                      errors = { ...errors, phone: phoneError };
                    }
                    // alert(values.phone)
                    // alert(values.phone.length + '/' + (values.phone.length <= 9))
                    // if(values.phone.replace(/\s/g, "").length < 9) {
                    //   errors = {...errors, phone : t("Invalid")};
                    // }
                    // for (var i = 0; i < values.phone.replace(/\s/g, "").length; i++) {
                    //   if(values.phone.replace(/\s/g, "").charAt(i) >= '0' && values.phone.replace(/\s/g, "").charAt(i) <= '9'){
                    //     continue;
                    //   }
                    //   else if(!(i === 0 && values.phone.replace(/\s/g, "").charAt(i) === '+')) {
                    //     errors = {...errors, phone : t("Invalid")};
                    //     break;
                    //   }    
                    // }

                    if (!values.address) {
                      errors = { ...errors, address: "Wymagane pole" };
                    }
                    if (!values.phone) {
                      errors = { ...errors, phone: "Wymagane pole" };
                    }
                    if (await this.sprawdzNIP2(values.NIP)) {
                     errors = { ...errors, NIP: "Niepoprawny numer NIP" }; //Nie udało się wyszukać w bazie GUS
                    }
                    //if (!values.NIP) {
                    //  errors = { ...errors, NIP: "" };
                    //}
                    return errors;
                  }}
                  onSubmit={(values, actions) => {
                    actions.setSubmitting(false)
                    if (this.props.info.www_sprzedaz_error !== 0) {
                      this.setState({ ...this.state, openStatus: true });
                    } else {
                      setTimeout(() => {
                        if (this.props.contact.payWeb.toString() === "4") {
                          this.setState({ openPaymentMethod: true, userInfo: values })
                        } else {
                          this.handleSend(values, this.props.contact.payWeb.toString())
                        }

                      }, 100)
                    }
                    //       if(this.state.tickets > 0){
                    //         this.setState({ ...this.state, phone: values.phone });
                    //         setTimeout(() => {
                    //           this.handleSend( values, t, sum.toFixed(2).toString() );
                    //           formikActions.setSubmitting(false)
                    // //          formikActions.resetForm()
                    //         }, 500)
                    //       } else {
                    //         formikActions.setSubmitting(false)
                    //       }

                  }}
                  render={({ submitForm, isSubmitting, values, setFieldValue, handleChange, touched, errors, handleBlur }: FormikProps<Values>) => (
                    <Form className={classes.form}>
                      <Dialog
                        disableEscapeKeyDown
                        maxWidth="xs"
                        open={this.state.openNIP}
                        fullWidth
                      >
                        <DialogTitle disableTypography>
                          <Typography variant="h5" component="h2" style={{ fontSize: "1.25rem" }} color={this.state.NIP.nazwa ? 'primary' : 'error'}>
                            <b>{this.state.NIP.nazwa ? 'dane o NIP' : 'niepowodzenie'}</b>
                          </Typography>
                          <hr />
                        </DialogTitle>
                        <DialogContent >
                          {this.state.NIP.nazwa ?
                            (
                              <React.Fragment>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  {wciecie + 'dane dla NIP: '}
                                  <b className={classes.primary}>{this.state.NIP.nipOdpowiedz}</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  {wciecie + 'nazwa: '}
                                  <b className={classes.primary}>{this.state.NIP.nazwa.length > 30 ? obetnijTekst(this.state.NIP.nazwa, 30) : this.state.NIP.nazwa}</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  {wciecie + 'miejscowość: '}
                                  <b className={classes.primary}>{this.state.NIP.miejscowosc}</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  {wciecie + 'kod pocztowy: '}
                                  <b className={classes.primary}>{this.state.NIP.kodPocztowy}</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  {wciecie + 'ulica: '}
                                  <b className={classes.primary}>{this.state.NIP.ulica}</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  {' '}
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  Czy dane są poprawne?
                                </DialogContentText>
                              </React.Fragment>
                            ) :
                            (
                              <React.Fragment>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  Uwaga
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  {wciecie + 'nie udało się wyszukać w bazie '}
                                  <b className={classes.error}>GUS</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  {wciecie + 'danych dla firmy z NIP '}
                                  <b className={classes.error}>{this.state.NIP.nipOdpowiedz}</b>
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  {' '}
                                </DialogContentText>
                                <DialogContentText variant="h5" component="h2" className={classes.dialogContentText}>
                                  Czy chcesz wpisać je ponownie?
                                </DialogContentText>
                              </React.Fragment>
                            )}
                        </DialogContent>
                        <DialogActions >
                          {this.state.NIP.nazwa ?
                            (
                              <React.Fragment>
                                <Button
                                  onClick={() => this.setState({ ...this.state, openNIP: false })}
                                  variant="outlined" size="small" color="primary"
                                  className={classes.actionButtons}>
                                  <b><Trans>nie</Trans></b>
                                </Button>
                                <Button
                                  variant="contained" size="small" color="primary"
                                  disabled={isSubmitting}
                                  onClick={submitForm}
                                  className={classes.actionButtons}>
                                  <b><Trans>tak</Trans></b>
                                </Button>
                              </React.Fragment>
                            ) :
                            (
                              <ThemeProvider theme={outerTheme}>
                                <Button
                                  disabled={isSubmitting}
                                  onClick={submitForm}
                                  variant="outlined" size="small" color="secondary"
                                  className={classes.actionButtons}>
                                  <b><Trans>nie</Trans></b>
                                </Button>
                                <Button
                                  onClick={() => this.setState({ ...this.state, openNIP: false })}
                                  variant="contained" size="small" color="secondary"
                                  className={classes.actionButtons}>
                                  <b><Trans>tak</Trans></b>
                                </Button>
                              </ThemeProvider>
                            )}
                        </DialogActions>
                      </Dialog>
                      {renderFields(this.formikFields(setFieldValue, values, handleChange, touched, errors, handleBlur))}

                      <Typography className={`${classes.label} ${classes.error} ${classes.legend}`} style={{marginTop: CONFIG.inPost === "1" ? "0px" : "30px",}}>
                        <Trans>Field must be filled</Trans>
                      </Typography>

                    { CONFIG.inPost === "1" ? <>
                      <Typography
                        gutterBottom variant="h5" component="h2" color="primary"
                        className={classes.dialogTitleTypography} style={{marginTop: "12px"}}>
                        <b>wybierz rodzaj dostawy</b>
                      </Typography>
                      <hr className={classes.hr} />

                              <div onClick={() => this.selectKurier(2)} className={`${classes.border} ${this.state.kurier === 2 ? classes.selectedBorder : null}`} style={{marginBottom: "6px"}}>
                                
                              <Grid container spacing={0} style={{ padding: "0px" }}>
                                <Grid item xs={12} sm={5}>
                                  <Typography gutterBottom variant="h6" component="h2">Paczkomat InPost</Typography>
                                  <Typography gutterBottom variant="h6" component="h2">Cena od : 9,99zł</Typography>
                                  {this.state.kurier === 2 ?
                                  <Typography gutterBottom variant="h6" component="h2" onClick={this.setOpenMapaInpost} style={{color: 'blue'}}>{!wybranyPaczkomat ? "Wybierz" : "Zmień"} Paczkomat na mapie</Typography>
                                  : null}

                                </Grid>

                                <Grid item xs={12} sm={7}>
                                  {this.state.kurier === 2 && wybranyPaczkomat?
                                      <> 
                                      <Typography gutterBottom variant="h6" component="h2" color="primary"><b>Paczkomat {this.state.paczkomat.name}</b></Typography>
                                      <Typography gutterBottom variant="h6" component="h2">{this.state.paczkomat.address.line1}, {this.state.paczkomat.address_details.city}</Typography>
                                      <Typography gutterBottom variant="h6" component="h2">Opis: {this.state.paczkomat.location_description}</Typography>
                                      </>
                                    : null } 
                                </Grid>
          
                              </Grid>

                                 
                                {/* {this.state.kurier === 2 ?
                                  <>
                                    <p onClick={this.setOpenMapaInpost} style={{color: "blue"}} >{!wybranyPaczkomat ? "Wybierz" : "Zmień"} Paczkomat na mapie</p>

                                    {wybranyPaczkomat ?
                                    <> 
                                    <p style={{fontWeight: "bold",}} className={classes.primary}>Paczkomat {this.state.paczkomat.name}</p>
                                    <p>{this.state.paczkomat.address.line1}, {this.state.paczkomat.address_details.city}</p>
                                    <p>Opis: {this.state.paczkomat.location_description}</p>
                                    </>
                                    : null}


                                  </>
                                  : null }  */}


                              </div>

                              <div onClick={() => this.selectKurier(1)} className={`${classes.border} ${this.state.kurier === 1 ? classes.selectedBorder : null}`} style={{marginTop: "12px"}}>
                                <Typography gutterBottom variant="h6" component="h2">Kurier InPost</Typography>
                                <Typography gutterBottom variant="h6" component="h2">Cena od : 11,99zł</Typography>
                              </div>


                              </> : null }
                              

                           


                      

                    
                      <DialogActions >
                        <Button
                          onClick={() => {this.props.close(); this.setForm(values)}}
                          variant="outlined" size="small" color="primary"
                          className={classes.actionButtons}>
                          <b><Trans>anuluj</Trans></b>
                        </Button>
                        <Button
                          variant="contained" size="small" color="primary"
                          disabled={isSubmitting || (CONFIG.inPost === "1" && ( this.state.kurier === 0 || this.state.kurier === 2 && !wybranyPaczkomat) ) }
    
                          onClick={values.NIP ? () => this.sprawdzNIP(values.NIP.replace(/\D/g, '')) : submitForm} 
                          className={classes.actionButtons}>
                          <b><Trans>zamów</Trans></b>
                        </Button>
                      </DialogActions>
                    </Form>
                  )}
                  
                />
              </Grid>
            </Grid>
            <DialogInfo open={this.state.openInfo} okCallback={this.submitDialogInfo} okText={"zatwierdź"} cancelCallback={this.closeDialogInfo} dialogContent={this.state.infoValues} />
            <DialogMapaInpost open={this.state.openMapaInpost} cancelCallback={this.setCloseMapaInpost} okCallback={this.pointSelect}/>
            
          </DialogContent >
        </Dialog>
      </>
    );
  }
}

const styles = (theme: Theme) => ({
  papper: {
    maxWidth: "600px"
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  label: {
    color: theme.palette.primary.main,
    //fontFamilly: "sans-serif",
    //fontSize: "small"
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight,
    padding: "7px 0 4px"
  },
  error: {
    color: theme.palette.error.main
  },
  blue: {
    color: "#3a87ad"
    //color : "#005a7e"
  },
  green: {
    color: "#458B00"
    //color : "#005a7e"
  },
  legend: {
    //marginTop: "30px",
    padding: "8px 8px 0px 0px"
  },
  textAlignLeft: {
    textAlign: "left" as "left",
  },
  fontWeightBold: {
    fontWeight: "bold" as "bold"
  },
  textField: {
    //color: "rgb(0, 0, 0)",
    //color: theme.palette.primary.dark,
    color: 'seagreen',
    padding: "8px 14px",
    fontSize: '16px',
  },
  hr: {
    marginTop: '10px'
  },
  dialogTitle: {
    padding: "0px",
  },
  floatLeft: {
    float: "left" as "left"
  },
  actionButtons: {
    textTransform: "lowercase" as "lowercase",
    fontSize: '0.8rem'
  },
  dialogTitleTypography: {
    fontSize: '1.25rem'
  },
  image: {
    height: "400px",
    width: "400px",
    margin: "auto",
    [theme.breakpoints.down('xs')]: {
      height: "280px",
      width: "280px",
    }
  },
  listText: {
    fontSize: "1rem"
  },
  button: {
    width: "100%",
    marginBottom: "10px",
    padding: "20px",
    fontSize: "1rem",
    textTransform: "none" as "none",
    fontWeight: "bold" as "bold"
  },
  dialogContentText: {
    whiteSpace: 'pre' as 'pre'
  },
  primary: {
    color: theme.palette.primary.main
  },
  border: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "7px",
    padding: "10px 15px",
    marginBottom: "12px",
    cursor: "pointer",
    width: "calc(100% + -47px)",
    "&:hover": {
      boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)"
    } 
  },
  selectedBorder: {
    borderWidth: "3px",
    borderColor: theme.palette.primary.main,
    width: "calc(100% + -50px)",
  }
   

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
  basket: state.pageState.basket,
  contact: state.pageState.contact,
  info: state.pageState.info,
  initialValues: state.pageState.initialValues,
  userData: state.pageState.userData,
  czarnaLista: state.pageState.czarnaLista,
  prefiksyPl: state.pageState.prefiksyPl,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogOrder));



// (<Grid item xs={12} md={6} style={{ paddingLeft: "12px" }}>
//   <DialogTitle disableTypography className={classes.dialogTitle}>
//     <Typography
//       gutterBottom variant="h5" component="h2" color="primary"
//       className={classes.dialogTitleTypography}>
//       <b>nasza firma</b>
//     </Typography>
//     <hr className={classes.hr} />
//   </DialogTitle>
//   {/* <div style={{margin: "1em auto auto", display: "flex"}}>
//                 <ResponsiveImgMaterialUi style={{height: "70%", width: "70%", margin: "auto"}} 
//                   xs={logoUrl}
//                   md={logoUrl}
//                   lg={logoUrl}
//                 /> 
//                 </div> */}
//   <CardMedia
//     //tclassName={classes.media}
//     className={classes.image}
//     image={this.logoUrl}
//   //title="logo"
//   />
// </Grid>)